module.exports = __webpack_public_path__ + "img/photo-0003.d6a69926.jpg";